import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";

const Testimonials = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData1 = await getPrincipalMessage();
         const principalData =principalData1.filter((item) => item.category ==='Principal' )
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
 
  return (
    <>
        {data.length > 0  && (
           <div className="message-container">
          <div className="messagebox">
            <div className="messagedesc">
              <div className="maintitle">
                <h3>{data[0].category}'s Message</h3>
              </div>
              <div className="msginfo">
                    <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
               </div>
            </div>
            <div className="mainbtn button">
              <Link to="/PrincipalMessage">READ MORE <i className="bi bi-arrow-right"></i></Link>
            </div>
            
          </div>

          <div className="messageimg">
            <div className="testimonialimg"> 
            <LazyLoad> 
            {data[0].attachments && data[0].attachments.length > 0 ? (<img
              src={`https://webapi.entab.info/api/image/${data[0].attachments}`}
              alt="SPCSH"
              className="img-fluid"
            />) : (<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg" alt="SPCSH" className="img-fluid" />)}
            </LazyLoad>
            </div>
            <div className="messageboximg">
              <p>
              {data[0].name} <span> {data[0].category}</span> 
              </p>
            </div>
          </div>
        </div>
          )}
          {data.length === 0  && (
          <div className="message-container">
          <div className="messagebox">
            <div className="messagedesc">
              <div className="maintitle">
                <h3>Principal's Message</h3>
              </div>
              <p> As Principal of St. Peter’s Convent School, it is both a privilege and a joy to witness the quiet miracle of growth that unfolds in each child. Every student who enters our care is a distinct and divine creation—genetically unique, culturally enriched, and morally formed. We believe, as St. Kuriakose Elias Chavara [Founder of our Congregation-CMC] beautifully expressed, that “Children are a gift from God in the hands of their parents.” With that same reverence, we at St. Peter’s are entrusted with the sacred task of nurturing them.</p>
            </div>
            <div className="mainbtn button">
              <Link to="/PrincipalMessage">READ MORE <i className="bi bi-arrow-right"></i></Link>
            </div>
            
          </div>

          <div className="messageimg">
            <div className="testimonialimg">
              <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/Principal.jpg" alt="SPCSH" className="img-fluid" /></LazyLoad>
            </div>
            <div className="messageboximg">
              <p>
              DR. SR. SHARON THERESE CMC<span> Principal</span> 
              </p>
            </div>
          </div>
        </div>
          )}  
        
    </>
  );
};

export default Testimonials;
